<template>
    <section class="hero is-medium">
        <div class="hero-body">
            <div class="container has-text-centered">
                <div class="column is-4 is-offset-4">
                    <p class="title is-4 has-text-white-ter">Please wait...</p>
                    <span class="icon is-medium has-text-grey-lighter">
                        <i class="fas fa-circle-notch fa-2x fa-pulse"></i>
                    </span>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
import Vue from 'vue';

import authService from '../../../../../_common/services/authentication.service';

export default {
    name: 'fastlogin',
    computed: {
        loginKey: function() {
            return this.$route.params.loginKey;
        }
    },
    async mounted() {
        if (this.loginKey) {
            const loginResult = await authService.fastlogin(this.loginKey);
            if (loginResult && loginResult.isSuccess) {
                this.play();
            } else {
                this.$router.push({ path: '/' });
            }
        }
    },
    methods: {
        async play() {
            await Vue.state.player.reload();
            Vue.state.lang.ensureLocalLangOrPlayer((Vue.state.player.isLoggedIn() && Vue.state.player.get().lang) || 'ru');
            await Vue.router.teleport.home();
        }
    }
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/fastlogin.vue